import { render, staticRenderFns } from "./components.checkbox.vue?vue&type=template&id=4dada2be"
import script from "./components.checkbox.vue?vue&type=script&lang=js"
export * from "./components.checkbox.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports